var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-item-div1"},[_c('el-container',[_c('el-aside',{attrs:{"width":"260px"}},[_c('LeftMenu',{attrs:{"itemMenu":_vm.itemMenu}})],1),_vm._v(" "),_c('el-main',{staticStyle:{"padding":"20px 0px 20px 50px","overflow":"visible"}},[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-66fd28e7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/item/ItemIndex.vue
// module id = null
// module chunks = 